module.exports = __webpack_public_path__ + "static/media/black-price.38d46fc7.svg";